var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ideogram-show"},[_c('ideograms-show',{ref:"first-ideogram-show",attrs:{"pinyin":_vm.pinyin,"character":_vm.ideograms,"highlights":_vm.highlights}}),(_vm.secondOnlyDiff)?[_vm._v("[ "),_c('ideograms-show',{ref:"second-ideogram-show",attrs:{"pinyin":_vm.pinyin,"character":_vm.secondOnlyDiff}}),_vm._v("] ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }